import { getUser } from "../../utils/local-storage";
import MessageCard from "./MessageCard"

const MessageCardAwsAccountCostReport = ({ condition }: { condition: boolean }) => {
    const profile = getUser();
    const email = (profile || {}).email;

    return !condition ? null : (
        <MessageCard
            type={"domain-info"}
            text={
                <div>
                    Once you connect an AWS account to your environment, you will start receiving <b>weekly cost report emails</b> at <i>{email}</i>
                </div>
            }
            icon={false}
            style={{ marginTop: 24 }}
        />
    );
}

export default MessageCardAwsAccountCostReport;